<div class="filters-wrapper" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <!-- Trigger button -->
  <button class="filter-btn" [class.filter-btn--active]="activeCount > 0" (click)="togglePanel()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
    {{ label }}
    <span class="badge" *ngIf="activeCount > 0">{{ activeCount }}</span>
  </button>

  <!-- Filter panel -->
  <div class="filter-panel" *ngIf="isOpen">
    <div class="filter-panel__header">
      <span class="filter-panel__title">
        {{ 'shared-components.class-range-filters.panel-title' | translate }}
      </span>
      <button class="filter-panel__clear" *ngIf="activeCount > 0" (click)="clearFilters()">
        {{ 'shared-components.class-range-filters.clear-filters' | translate }}
      </button>
    </div>

    <div class="filter-panel__body">
      <!-- Progress filter -->
      <div class="filter-group">
        <label class="filter-label">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          {{ 'shared-components.class-range-filters.progress-label' | translate }}
        </label>
        <div class="filter-input-row">
          <input
            type="range"
            class="filter-slider"
            min="0" max="100" step="5"
            [value]="minProgress ?? 0"
            (input)="onProgressChange($any($event.target).value)"
          />
          <span class="filter-value">{{ minProgress ?? 0 }}%</span>
        </div>
        <div class="filter-ticks">
          <span>0%</span>
          <span>25%</span>
          <span>50%</span>
          <span>75%</span>
          <span>100%</span>
        </div>
      </div>

      <!-- Chapters filter (stepper) -->
      <div class="filter-group">
        <span class="filter-label filter-label--chapters">
          {{
            (mode === 'classes'
              ? 'shared-components.class-range-filters.chapters-label-classes'
              : 'shared-components.class-range-filters.chapters-label-users'
            ) | translate
          }}
        </span>
        <div class="filter-stepper">
          <button
            type="button"
            class="filter-stepper__btn filter-stepper__btn--minus"
            [disabled]="(minChapters ?? 0) <= 0"
            (click)="decrementChapters()"
            [attr.aria-label]="'shared-components.class-range-filters.decrease' | translate"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="3" y1="7" x2="11" y2="7"></line>
            </svg>
          </button>
          <div class="filter-stepper__value">{{ formattedChapters }}</div>
          <button
            type="button"
            class="filter-stepper__btn filter-stepper__btn--plus"
            (click)="incrementChapters()"
            [attr.aria-label]="'shared-components.class-range-filters.increase' | translate"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="7" y1="3" x2="7" y2="11"></line>
              <line x1="3" y1="7" x2="11" y2="7"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
